<template>
  <v-main style="background-color: #b0bec5" >
    <v-container fluid style="max-width: 400px; height: 100%;" class="pa-0 d-flex">
      <vue-headful title="Team-Dashboard" description="Aimz"/>
        <div class="d-flex pa-0" style="width: 100%;">
          <v-col class="mt-3 d-flex align-stretch pa-0">
            <v-container fluid class="pa-0 pl-2 pt-2" id="dashboard_container">
              <week-paginator :date="date" :nr="bereichNr" class="mr-2 mb-2" base-url="/team_dashboard/"></week-paginator>
              <v-card class="mr-2 mb-2">
                <v-treeview activatable :active.sync="currentEmail" color="info" :items="tree">
                  <template v-slot:append="{ item }">
                    <span class="body-2">{{getIndex(item)}}</span>
                  </template>
                </v-treeview>
              </v-card>
              <team-index-week v-if="bereichNr===undefined" :date="date" :treenode="currentTreeNode"
                          :loading="loading" class="mr-2 mb-2"></team-index-week>
              <!--    <bereich-index-week2 :values="week_all_indices" :weights="bereich_weights" :loading="loading" :stacked="false"></bereich-index-week2>-->
              <!--    <bereich-index-week2 :values="week_all_indices" :weights="bereich_weights" :loading="loading" :stacked="true"></bereich-index-week2>-->
<!--              <sub-content-switcher v-model="subContentIndex" v-if="bereichNr===undefined"/>-->

              <div v-if="bereichNr===undefined && subContentIndex==0" class="d-flex flex-row flex-wrap">
                <team-bereich-week v-for="(bereich,i) in bereiche" :nr="i" :treenode="currentTreeNode" :date="date" :bereich="bereich"
                              :key="bereich" :loading="loading" v-if="isBereichShown(bereich)"/>
              </div>
              <template v-if="bereichNr!==undefined">
                <v-row class="d-flex justify-space-between ml-0 mr-2">
                  <v-btn class="mb-2" :to="toOverview">Zur Übersicht</v-btn>
                  <v-btn class="mb-2" :to="toNext">{{ nextBereich }}</v-btn>
                </v-row>
                <team-bereich-week :treenode="currentTreeNode" :bereich="b" :key="'_'+b" :loading="loading"/>
<!--                <sub-content-switcher v-model="subContentIndex" class="mr-2"/>-->
                <div class="d-flex flex-row flex-wrap" v-if="subContentIndex==0">
                  <team-num-value-week :date="date" :activity="activity" v-for="(activity,i) in validActivities"
                                 :treenode="currentTreeNode" :targets="targets" :key="activity.id"/>
                </div>
              </template>
<!--              <comments v-if="subContentIndex==1" :date="date" :bereich="b||'all'"/>-->
            </v-container>
          </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Activities from "@/components/Activities";
import UserLib from "@/components/UserLib";
import TeamBereichWeek from "@/components/Charts/TeamBereichWeek";
import TeamIndexWeek from "@/components/Charts/TeamIndexWeek";
import Kinds from "@/components/Kinds";
import BereichIndexWeek from "@/components/Charts/BereichIndexWeek";
import Bereiche from "@/components/Bereiche";
import BereichIndexWeek2 from "@/components/Charts/BereichIndexWeek2";
import ActivityLibrary from "@/components/ActivityLibrary";
import WeekPaginator from "@/components/Charts/WeekPaginator";
import {convertToInt} from "@/reusable/typeconversion";
import SubContentSwitcher from "@/components/Charts/SubContentSwitcher";
import Comments from "@/components/Comments";
import {ArrayX} from "@/reusable/array_extensions";
import TeamNumValueWeek from "@/components/Charts/TeamNumValueWeek";
import {Ziele} from "@/components/Ziele";

const {DateTime} = require("luxon");

export default {
  name: 'TeamDashboard',
  components: {CenterContainer, Comments, SubContentSwitcher, WeekPaginator, TeamIndexWeek, BereichIndexWeek2, TeamBereichWeek, TeamNumValueWeek},
  data() {
    return {
      date: undefined,
      dateTime: undefined,
      isodate: undefined,
      subContentIndex: 0,
      week_index: {},
      activities: [],
      loading: false,
      bereichNr: undefined,
      b: undefined,
      nextBereich: undefined,
      currentEmail: [],
      currentTreeNode: {},
      tree: [],
      targets: undefined,
      currentTargets:undefined,
    }
  },
  mounted() {
    if (this.$app.desktop)
      this.$app.show_drawer = true;
    this.routeChanged(this.$route);
    this.$nextTick(this.check_session)
  },
  beforeRouteUpdate(to, from, next) {
    //console.log("beforeRouteChanged", to);
    this.routeChanged(this.$route);
    next();
  },
  methods: {
    async check_session() {
      this.exit_if_not_logged_in();
      var user=await this.$backend.check_session();
      this.$app.save("user", user);
      this.exit_if_not_logged_in();
    },
    routeChanged(route) {
      if (route.params.date)
        this.date = new Date(route.params.date);
      else
        this.date = new Date(Date.now());
      var dateTime = DateTime.fromJSDate(this.date).setLocale("de");
      console.log({route, date: this.date, dateTime, weekday: dateTime.weekday});
      if (dateTime.weekday !== 1)
        dateTime = dateTime.startOf("week");
      console.log("after weekstart", {dateTime})
      this.dateTime = dateTime;
      this.date = dateTime.toJSDate();
      this.isodate = this.dateTime.toISODate();
      if (route.params.bereichNr) {
        this.bereichNr = convertToInt(route.params.bereichNr);
        this.b = this.getBereich();
        this.nextBereich = this.getNextBereich();
      } else {
        this.bereichNr = undefined;
        this.b = undefined;
        this.nextBereich = undefined;
      }
      this.reload();
    },
    exit_if_not_logged_in() {
      if (!this.$app.is_logged_in) {
        this.$store.commit("set", {key: "intern", value: false});
        if (this.$route.path != "/")
          this.$router.replace("/");
        return;
      }
      this.$store.commit("set", {key: "intern", value: true});
    },
    async reload() {
      this.loading = true;
      var route = this.$route;
      if (route.params.date)
        this.date = new Date(route.params.date);
      else
        this.date = new Date(Date.now());
      var dateTime = DateTime.fromJSDate(this.date).setLocale("de");
      if (dateTime.weekday != 1)
        dateTime = dateTime.startOf("week");
      console.log("after weekstart", {dateTime})
      this.dateTime = dateTime;
      this.date = dateTime.toJSDate();
      this.isodate = this.dateTime.toISODate();
      this.tree = await this.$backend.get_team_tree(this.isodate) ?? [];
      console.log("team tree: " + this.tree);
      console.log("dashboard: " + this.isodate);
      if (this.currentEmail.length===0 && this.tree && this.tree[0]) {
        this.currentEmail[0]=this.tree[0].id;
      }
      //this.week_index = await this.$backend.get_object(Kinds.KIND_INDEX, );
      this.updateIndex();
      this.loading = false;
      if (this.b) {
        var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY);
        if (!activities)
          return;
        activities=ActivityLibrary.filterActivitiesByDate(activities, this.dateTime);
        activities.forEach(x=>x.sortKey||=0);
        this.activities = new ArrayX(activities.filter(a => a.bereich == this.b)).sortBy(a=>a.sortKey);
      }
    },
    async loadTargets() {
      this.targets=(await this.$backend.get_ziele(this.dateTime.year, this.currentEmail[0])||{});
      this.currentTargets=new Ziele(this.targets).getCurrentTargets();
    },
    getCurrentTarget(activity) {
      if (!this.currentTargets)
        return 1;
      if (this.currentTargets[activity.id])
        return this.currentTargets[activity.id];
      return undefined;
    },
    updateIndex() {
      var email= this.currentEmail[0];
      if (!email) {
        this.week_index = {};
        return;
      }
      this.currentTreeNode = this.findCurrentTreeNode(this.tree, email);
      this.loadTargets();
    },
    findCurrentTreeNode(tree, email) {
      if (!tree)
        return undefined;
      for(let node of tree) {
        if (node.id===email) {
          return node;
        }
        var n=this.findCurrentTreeNode(node.children, email);
        if (n)
          return n;
      }
    },
    getIndex(treenode) {
      var n=treenode;
      if (n.index!==undefined) {
        return Math.round(n.index.index || 0);
      } else if (n.teamIndex!==undefined) {
        return Math.round(n.teamIndex["total/index"]||0);
      } else {
        return 0;
      }
    },
    isBereichShown(bereich) {
      return this.$app.isBereichShown(bereich);
    },
    getBereich() {
      if (this.bereichNr === undefined)
        return undefined;
      return this.bereiche[this.bereichNr];
    },
    getNextBereich() {
      if (this.bereichNr === undefined)
        return undefined;
      return this.$app.getBereichName(this.bereiche[(this.bereichNr + 1) % this.bereiche.length]);
    },
  },
  computed: {
    app() {
      return this.$app;
    },
    bereiche() {
      return this.$app.bereiche.map(x=>x.bid);
    },
    validActivities() {
      return this.activities.filter(a => a.name && (this.getCurrentTarget(a) || 0)>0 || (a.type===ActivityLibrary.TYPE_BOOL && a.freq===ActivityLibrary.FREQ_DAILY));
    },
    toOverview() {
      return '/team_dashboard/' + this.isodate;
    },
    toNext() {
      return '/team_dashboard/' + this.isodate + '/' + ((this.bereichNr + 1) % this.bereiche.length);
    }
  },
  watch: {
    $route(to, from) {
      this.routeChanged(to);
    },
    currentEmail: {
      deep: true,
      handler(n) {
        this.updateIndex();
      }
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>